import { forwardRef } from 'react'
import { useTranslation } from 'react-i18next'

import type { AddCartButtonProps } from './type'

import { AddShoppingCartFilledIcon } from '@/components/icons/AddShoppingCartFilled'
import { Button, Dialog, Icon } from '@/components/ui'
import { useModal } from '@/hooks/util'

import { AddCartForm } from './AddCartForm'

export const AddCartButton = forwardRef<HTMLButtonElement, AddCartButtonProps>(
  ({ items, disabled = false }, ref) => {
    const { t } = useTranslation()
    const { close, open, isOpen } = useModal()

    return (
      <>
        <Button
          ref={ref}
          disabled={disabled}
          isBlock={true}
          startIcon={
            <Icon
              icon={AddShoppingCartFilledIcon}
              size={'2xl'}
              color={'white'}
            />
          }
          onClick={open}
        >
          {t('item.cart.add')}
        </Button>

        <Dialog title={t('item.cart.edit')} isOpen={isOpen}>
          {!!items.length && (
            <AddCartForm items={items} onSubmit={close} onClickCancel={close} />
          )}
        </Dialog>
      </>
    )
  }
)

AddCartButton.displayName = 'AddCartButton'
